<!--首页 搜索框、公告等其他显示-->
<template>
  <div class="gray-back" style="padding:.2rem 0 0 0 ;">
    <div style="margin:0 .2rem .2rem 0;text-align: right">
      <van-button v-rblink="{name: 'QcxjSearchIndex'}">切换至考级中心（点）</van-button>
    </div>
    <van-search placeholder="搜索俱乐部" v-model="params.keywords" @input="onSearch" style="margin-bottom: .2rem"/>

    <van-cell-group   >
      <van-cell class="qcxj-search-title">{{params.keywords ? '搜索"'+params.keywords + '"结果': '为您推荐：五星俱乐部'}}</van-cell>
      <van-cell :value="item.danwei + item.clubleixing" class="flex-start" is-link v-for="(item, index) in list"
                v-rblink="{name: 'ClubDetailUnbind',query: {id: item.id}}">
        <template #icon>
          <img :src="item.pic_url" alt="" style="height: 1.2rem;margin-right: .3rem">
        </template>
      </van-cell>
      <div style="height: 10px"></div>

      <van-cell class="qcxj-search-title">公告</van-cell>
      <van-cell :value="item.title" class="flex-start" is-link v-for="(item, index) in noticeList" v-rblink="{name: 'NewsDetail', query:{id: item.id}}"></van-cell>
      <div style="height: 10px"></div>


    </van-cell-group>


    <van-pull-refresh v-model="isLoading2" @refresh="onRefresh">
      <van-list
          v-model="loading2"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-tabs
            v-model="active"
            :class="row.bg_show ? 'active-tab' : ''"
            sticky
            @click="onClick"
        >
          <van-tab
              v-for="(item, index) in activeTab"
              :key="index"
              :type="index"
          >
            <template #title>
              <span class="active-tab-num" v-if="item.num > 0">{{
                  item.num
                }}</span>
              {{ item.name }}
            </template>
            <div :key="i" v-for="(item, i) in list2">
              <div
                  v-rblink="{ name: 'NewsDetail', query: { id: item.id } }"
                  v-if="item.style == '-1'"
              >
                <!-- 无图 style==1 -->
                <NewsItem1 :row="item" v-if="item.pics.length == 0"></NewsItem1>
                <!-- 有图 style==2 -->
                <NewsItem2 :row="item" v-if="item.pics.length == 1"></NewsItem2>
                <!-- 视频 style==3 -->
                <NewsItem3 v-if="false"></NewsItem3>
                <!-- 多图 style==4 -->
                <NewsItem4 :row="item" v-if="item.pics.length > 1"></NewsItem4>
              </div>

              <!-- 小图 style==1 -->
              <Activity1
                  v-if="item.style == '1'"
                  :content="item"
                  :index="i"
              ></Activity1>

              <!-- 视频 style==2 -->
              <Activity2
                  v-if="item.style == '2'"
                  :content="item"
                  :index="i"
              ></Activity2>

              <!-- 视频带评论 style==3 -->
              <Activity3
                  v-if="item.style == '3'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event, item, i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event, item, i)"
                  @deleteComment="onDeleteComment($event, i)"
              ></Activity3>

              <!-- 多图带评论 style==4 -->
              <Activity4
                  v-if="item.style == '4'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event, item, i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event, item, i)"
                  @deleteComment="onDeleteComment($event, i)"
              ></Activity4>
              <Activity5
                  v-if="item.style == '5'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event, item, i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event, item, i)"
                  @deleteComment="onDeleteComment($event, i)"
              ></Activity5>
            </div>
          </van-tab>
        </van-tabs>
        <div class="comment-bottom" v-if="sendShow">
          <div class="send-comment">
            <van-field
                v-model="message"
                :placeholder="placeholder"
                show-word-limit
            />
            <div class="send-btn" @click="onCommentSend">发送</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>


    <div class="savebtn">
      <van-button
          v-if="!row.club.length"
          style="width: 6rem"
          size="large" round >您当前尚未绑定俱乐部</van-button>
      <van-button
          v-else
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 6rem"
          size="large" round @click="toCenter" >进入我的俱乐部</van-button>
    </div>

    <div style="height: 1rem"></div>

    <van-action-sheet v-model="clubShow" title="我的考级中心/点">
      <van-cell-group>
        <van-cell :title="item.danwei + item.clubleixing" is-link v-for="(item, index) in row.club" @click="toCheck(item.id)" />
      </van-cell-group>
    </van-action-sheet>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    <NavFloatAdd :id="this.aparams.id" :back="1"></NavFloatAdd>
  </div>
</template>
<style scoped>
.qcxj-search-title {
  font-size: 16px;
  font-weight: 700;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

.send-btn {
  width: 1.3rem;
  height: 38px;
  background: linear-gradient(
      90deg,
      rgba(254, 200, 53, 1) 0%,
      rgba(255, 173, 25, 1) 100%
  );
  border-radius: 4px;
  margin-left: 12px;
  line-height: 38px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.send-comment {
  width: 7.1rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.comment-bottom {
  position: fixed;
  bottom: 1rem;
  width: 100%;
  height: 1.08rem;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(236, 236, 236, 1);
}

.release-time-right {
  display: flex;
}

.icon-zan-comment-box {
  width: 175px;
  height: 38.5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
}

.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';
import Activity1 from "@/components/activity/Activity1.vue";
import Activity2 from "@/components/activity/Activity2.vue";
import Activity3 from "@/components/activity/Activity3.vue";
import Activity4 from "@/components/activity/Activity4.vue";
import Activity5 from "@/components/activity/Activity5.vue";
import NavFloatAdd from "@/components/NavFloatAdd.vue";

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);

export default {
  name: 'ClubSearchIndex',
  components: {
    PicUploader,
    LoginDialog,

    Activity1,
    Activity2,
    Activity3,
    Activity4,
    Activity5,
    NavFloatAdd,
  },
  data: function () {
    return {
      validator,
      isLoading: false,
      isLoading2: false,
      loginShow: false,
      clubShow: false,
      finished: false, 
      loading:false,
      loading2:false,
      saveLoading: false,
      showArea: false,
      submitType: '',
      showArea: false,
      message: '',
      sendShow: false,
      list2:[],
      params: {
        keywords: '',
        pageNo: 1,
        pageSize: 10
      },
      paramsNotice: {
        keywords: '',
        pageNo: 1,
        pageSize: 5
      },
      list: [],
      noticeList: [],
      row: {
        danwei: {},
        exame_center: {},
        club: {},
        list:[]
      },
      formData: {},
      active: 0,
      activeTab: [
        // { name: "文件", num: 0, type: -1 },
        {name: "动态", num: 0, type: 0},
        {name: "图片", num: 0, type: 1},
        {name: "视频", num: 0, type: 2}
      ],
      aparams: {
        id: 231,
        type: 0, // -1文件 0动态 1是图片  2是视频
        pageNo: 1,
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "搜索俱乐部"

    this.fetch();
    this.getList();
    this.getNoticeList();
    that.afetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/certClubIndex', {}, (res) => {
        that.row = res.data;
      }, (res) => {
        console.log('errrrrr')
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    getList() {
      let that = this;
      that.$api.get('/api/club/clubList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      })
    },

    getNoticeList() {
      let that = this;
      that.$api.get('/api/cms/cmsList', that.paramsNotice, (res) => {

        that.noticeList = res.data.list
      })
    },

    toCenter() {
      let that = this,
          centerList =that.row.club
      if(centerList.length === 1) {
        rbLink({
          name: 'ClubDetailMine',
          query: {
            id: centerList[0].id
          }
        })
      } else if(centerList.length > 1) {
        that.clubShow = true
      } else {
        Toast('暂无绑定的俱乐部')
      }

    },

    toCheck(id) {
      rbLink({
        name: 'ClubDetailMine',
        query: {
          id: id
        }
      })
    },
    onSearch() {
      let that =this
      that.loading = [];
      that.params.pageNo = 1
      that.list = []

      if(that.params.keywords) {
        that.params.grade = ''
      } else {
        that.params.grade = '五星'
      }
      that.getList()
    },


    unbind() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除单位认证吗?'
      }).then(() => {

        that.$api.post('/api/danwei/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
      this.afetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

    onRefresh() {
      let that = this;
      that.aparams.pageNo = 1;
      that.afetch();
    },

    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.aparams.pageNo > 1) {
        setTimeout(() => {
          this.afetch();
        }, 500);
      }
    },


    afetch() {
      let that = this;
      that.$api.get(
          "/api/activity/activity",
          that.aparams,
          (res) => {
            that.loading2 = false;

            if (res.data.list.currentpage == 1) {
              that.isLoading2 = false;
              that.list2 = res.data.list.list;
            } else {
              that.list2 = that.list2.concat(res.data.list.list);
            }

            if (res.data.list.list.length == 0) {
              that.finished = true;
            }
            that.aparams.pageNo += 1;
          },
          (res) => {
            // Toast(res.msg);

            console.log("没有登录");
            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {},
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true;
            } else {
              Toast(res.msg);
            }
          }
      );
    },

    onClick(name, title) {
      console.log(name);
      this.aparams.type = this.activeTab[name].type;
      this.aparams.pageNo = 1;
      this.fetch();
    },
    toActivityDetail(item) {
      let that = this;
      that.$router.push({
        path: "/activity-activity-detail",
        query: {
          id: item.id,
        },
      });
    },

    onSendBox(event, item, i) {
      // console.log(event)
      this.sendShow = event.sendShow;
      this.to_comment_id = event.comment_.id;
      this.placeholder = event.comment_.user_name
          ? "@" + event.comment_.user_name
          : "说点什么...";
      (this.item = item), (this.list_index = i);
    },

    onCommentSend() {
      let that = this;
      console.log("发送评论", this.item, this.message);
      that.$api.get(
          "/api/activity/commentAdd",
          {
            topic_id: this.item.id,
            content: this.message,
            to_comment_id: this.to_comment_id
          },
          res => {
            console.log(res);
            this.list2[this.list_index].comment_list.push(res.data);
            this.message = "";
          },
          res => {

            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {}
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true
            } else {
              Toast(res.msg);
            }
          }
      );
    },

  }
}
</script>



// WEBPACK FOOTER //
// ClubSearchIndex.vue?4b12a449